export default __webpack_public_path__ + "ced3ea5948bd1eb84b5844c436c78b17.png";